import React from "react";
import sekisoLogo from "../assets/client/sekiso.png";
import suzukiLogo from "../assets/client/suzuki.png";
import ingressLogo from "../assets/client/ingress.png";
import tsummitLogo from "../assets/client/tsummit.png";

// Import logo end user
import toyotaLogo from "../assets/client/toyota_logo.png";
import daihatsuLogo from "../assets/client/daihatsu_logo.png";
import mitsubishiLogo from "../assets/client/mitsubishi_logo.png";
import isuzuLogo from "../assets/client/Isuzu_logo.png";
import hyundaiLogo from "../assets/client/hyundai_logo.png";

const clients = [
  { name: "PT. Sekiso Industri Indonesia", logo: sekisoLogo },
  { name: "PT. Suzuki Indomobil Indonesia", logo: suzukiLogo },
  { name: "PT. Ingress Indonesia", logo: ingressLogo },
  { name: "PT. Indonesia T-Summit", logo: tsummitLogo },
];

const endUsers = [
  { name: "Toyota", logo: toyotaLogo },
  { name: "Daihatsu", logo: daihatsuLogo },
  { name: "Mitsubishi", logo: mitsubishiLogo },
  { name: "Isuzu", logo: isuzuLogo },
  { name: "Hyundai", logo: hyundaiLogo },
];

const Clients = () => {
  return (
    <section
      id="clients"
      style={{
        padding: "5rem 2rem",
        background: "linear-gradient(135deg, #fefce8, #f0fdf4, #ecfccb)",
      }}
    >
      {/* Judul */}
      <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
        <h2
          style={{
            fontSize: "2.2rem",
            fontWeight: "bold",
            color: "#111827",
            marginBottom: "0.5rem",
          }}
        >
          Our Clients
        </h2>
        <p style={{ color: "#4b5563", fontSize: "1rem" }}>
          Kami dipercaya oleh berbagai perusahaan ternama dalam industri otomotif dan manufaktur.
        </p>
      </div>

      {/* Slider Clients */}
      <div
        style={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          position: "relative",
          marginBottom: "3rem",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            animation: "scroll 25s linear infinite",
          }}
        >
          {[...clients, ...clients].map((c, i) => (
            <div
              key={i}
              style={{
                flex: "0 0 auto",
                width: "220px",
                margin: "0 2rem",
                textAlign: "center",
                transition: "transform 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.08)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1.0)")
              }
            >
              <img
                src={c.logo}
                alt={c.name}
                style={{
                  maxWidth: "100%",
                  height: "80px",
                  objectFit: "contain",
                  marginBottom: "0.8rem",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
                }}
              />
              <p
                style={{
                  fontSize: "0.9rem",
                  fontWeight: "500",
                  color: "#374151",
                }}
              >
                {c.name}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* End User Customer */}
      <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
        <h3
          style={{
            fontSize: "1.8rem",
            fontWeight: "bold",
            color: "#1f2937",
            marginBottom: "1.5rem",
          }}
        >
          End User Customer
        </h3>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "1.5rem",
        }}
      >
        {endUsers.map((u, idx) => (
          <div
            key={idx}
            style={{
              width: "150px",
              textAlign: "center",
              background: "white",
              padding: "1rem",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              transition: "transform 250ms ease, box-shadow 250ms ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.08) translateY(-6px)";
              e.currentTarget.style.boxShadow =
                "0 8px 20px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1) translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(0,0,0,0.1)";
            }}
          >
            <img
              src={u.logo}
              alt={u.name}
              style={{
                maxWidth: "100%",
                height: "55px",
                objectFit: "contain",
                marginBottom: "0.5rem",
              }}
            />
            <div
              style={{
                fontSize: "0.9rem",
                color: "#374151",
                fontWeight: "600",
              }}
            >
              {u.name}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
};

export default Clients;
